import React, { useState, useEffect, useRef } from "react";
import { InputNumber } from 'primereact/inputnumber';
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from 'primereact/inputtextarea';
import "../clap/FormulaireClap.scss";
import { useSelector } from "react-redux";
import { FieldBuilder } from "./../fields/FieldBuilder";
import { Toast } from "primereact/toast";
import { FileService } from "../../../service/FileService";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";





export const FormulaireSport = ({mode, oldForm}) => {
    const createMode = 'create';
    const editMode = 'edit';

    const usager = useSelector((state) => state.usager.user);
    const actionSociale = useSelector((state) => state.actionSociale);

    const [mapping, setMapping] = useState([]);
    const [enfants, setEnfants] = useState(actionSociale.enfants);
    const [currentEnfant, setCurrentEnfant] = useState();
    const [currentActionSociale, setCurrentActionSociale] = useState({});

    const [selectedEnfant, setSelectedEnfant] = useState(null);

    const [justificatifEnfant, setJustificatifEnfant] = useState([]);
    const [justificatifPresence, setJustificatifPresence] = useState([]);

    const [retourJustificatifEnfant, setRetourJustificatifEnfant] = useState(false);
    const [retourJustificatifPresence, setRetourJustificatifPresence] = useState(false);

    const [justificatifSupplementInformations, setJustificatifSupplementInformations] = useState([]);

    const [recapEnfant, setRecapEnfant] = useState('');

    const [policyOne, setPolicyOne] = useState(false);
    const [policyTwo, setPolicyTwo] = useState(false);

    const [displayBasic, setDisplayBasic] = useState(false);
    const [showFileUploadError, setShowFileUploadError] = useState(false);
    const [showDemandeError, setShowDemandeError] = useState(false);

    const [disabled, setDisabled] = useState(false);
    const [codeError, setCodeError] = useState(false);

    const [supplementErrone, setSupplementErrone] = useState(false);

    const [step, setStep] = useState(0);
    const [activeIndex, setActiveIndex] = useState([]);

    const actionSocialeService = new ActionSocialeService();
    const fileService = new FileService();
    const chequeCultureService = new ChequeCultureService();
    const linkService = new LinkProviderService();


    const [editCategoryJustif, setEditCategoryJustif] = useState(null);

    const [activities, setActivities] = useState([{name: '',price: null,}]);

    const [montantTotal, setMontantTotal] = useState(0);

    const [montantTotalByDlg, setMontantTotalByDlg] = useState(0);

    const [justifciatifButtonDisabled, setJustifciatifButtonDisabled] = useState(true);

    const [incompleteSelectedEnfant, setIncompleteSelectedEnfant] = useState(false);

    const [incompleteActivity, setIncompleteActivity] = useState(false);

    const [dateDebutFromJson, setDateDebutFromJson] = useState("");

    const toast = useRef(null);


    const editJustificatifMsg = 'Merci de renvoyer un document conforme.'

    const text =<div><p>Politique de protection des données à caractère personnel</p>
        <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
        <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et réglementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
       <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
        <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
        <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
        <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p></div>


    const mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

    const descriptionCategorie1="Avec le prénom et le nom de l'enfant, l'activité pratiquée, l'organisme ou l'association agrée, la période et le montant de l'abonnement ou de la cotisation payée.";

    const descriptionCategorie2="A mon nom avec l'activité pratiquée, l'organisme ou l'association agrée, la période et le montant de l'abonnement ou de la cotisation payée.";

    const descriptionCategorie11="Dans le cas où l'enfant ne figure pas sur la facture, je dois transmettre en plus une attestation au nom et prénom de l'enfant, signée et tamponnée par l'organisme ou l'association en charge de l'activité.";

    const descriptionCategorie21="Si mon nom et mon prénom ne sont pas sur la facture, je dois fournir en plus de la facture une attestation à mon nom et prénom, signée et tamponnée par l’organisme ou l’association en charge de l’activité.";


    const justificatifsCategoriesEnfant = [  //SLC ENFANTS 3743
        { "key": "191", "value": "Facture, reçu ou attestation de paiement de l'activité pratiquée" ,"description":descriptionCategorie1},
        { "key": "192", "value": "Attestation de l'organisme au nom et prénom de l'enfant (conditionnelle)" ,"description":descriptionCategorie11}
    ];

    const justificatifsCategoriesAdult = [  //SLC ADULTE 3742
        { "key": "191", "value": "Facture, reçu ou attestation de paiement de l'activité pratiquée" ,"description":descriptionCategorie2}
    ];

    const justificatifsCategories3 = [
        { "key": "059", "value": "Justificatif de présence en établissement" ,"description":"Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%."}
    ];

    const justificatifsCategoriesSupplement = [
            { "key": "999", "value": "Document complémentaire demandé par le C.G.O.S" ,"description":""}
    ];




   const handleFilesError = (error) => {
          if(error.response === undefined){
            displayErrorFile('Un des fichiers parmi vos justificatifs est endommagé, il ne peut pas être utilisé.\nRéparez ou remplacez le fichier et réessayez.')
          }else{
               localStorage.setItem("errorMessage", error.response.data.message)
               window.location ="/#/serviceIndisponible/FH-" + error.response.data.errorId;
          }
       }



    const checkAddJustifciatifButtonDisabled = () => {
       activities.forEach( activity => {
         if(!activity.name?.length){
            return true;
         }
         if(montantTotal < montantTotalByDlg){
            return true;
         }
       })
       if(activities?.length>0){
            return false;
       }else {
            return true;
       }

    }

    const onClickAjouterMesJustificatif=()=>{
        activities.forEach( product => {
                   if(product.name.length > 0 && product.price > 0 && product.dateFacture != null){
                                setIncompleteActivity(false);
                   }else{
                                setIncompleteActivity(true);
                   }
       });
    }

    useEffect(() => {
        if(createMode === mode) {
            fetchDataForCreation()
        } else if (editMode === mode) {
            fetchDataForEdition();
        } else {
            window.location.assign(linkService.getRetourEaLoginAgent());
        }
        initActiveIndex();
    }, []);

    useEffect(() => {
       setJustifciatifButtonDisabled(checkAddJustifciatifButtonDisabled());
    }, [activities]);

    useEffect(() => {
        getCurrentEnfant();
    }, [selectedEnfant]);

    useEffect(() => {
        setActiveIndex(prevState => [...prevState, step]);
    },[step]);


    const fetchDataForEdition = () => {
        let jsonObj = JSON.parse(oldForm.formJson);
        getCurrentActionSociale(actionSociale.listActionsSociale, actionSociale.cas, actionSociale.exercice);

        setMontantTotal(parseFloat(jsonObj.FORMULAIRE[jsonObj.FORMULAIRE.length-1].VALEUR));
        setSelectedEnfant(parseInt(jsonObj.FORMULAIRE[0].VALEUR));


        //load activities
        let _activities = [];

        jsonObj.FORMULAIRE.forEach( value => {
                  if(value.CODE == "NEA_ACTIVITE_LCI"){
                    let activitiesArray = value.VALEUR.split(' - ');
                    let dateFactureParts = activitiesArray[1].split('/');
                    let _dateFacture=new Date([dateFactureParts[2], dateFactureParts[1], dateFactureParts[0]].join('-'));
                    _activities.push({name: activitiesArray[0],price: parseFloat(activitiesArray[2]),dateFacture:_dateFacture});
                  }
                  if(value.CODE == "NEA_DATE_DEBUT_LCI"){
                    setDateDebutFromJson(value.VALEUR);
                  }
        });
        setActivities(_activities);
        Object.values(oldForm.filesToUpload).forEach(file => {
            if(justificatifsCategoriesEnfant.find(e => e.key === file.codeJustificatif) || justificatifsCategoriesAdult.find(e => e.key === file.codeJustificatif)) {
                setRetourJustificatifEnfant(true);
                if(actionSociale.cas =="3742"){
                 setEditCategoryJustif(justificatifsCategoriesAdult.find(e => e.key === file.codeJustificatif));
                }
            } else if(file.codeJustificatif === '059') {
                setRetourJustificatifPresence(true);
            } else if(file.codeJustificatif === '999') {
                setSupplementErrone(true);
            }
        });
        getMontantTotalByDlg(actionSociale.cas, usager.codeDelegation ,actionSociale.exercice);
    };



    const fetchDataForCreation = () => {

        actionSocialeService.getMappingFormulaireClap(actionSociale.exercice, actionSociale.cas).then(
            (res) => {
                setMapping(res.data);
            }
        );
        getCurrentActionSociale(actionSociale.listActionsSociale, actionSociale.cas, actionSociale.exercice);
        setMontantTotalByDlg(actionSocialeService.getMontantMinFrais());
    };

    const mapEnfants = () => {
        const items = [];
        enfants.forEach(e => items.push({"key": e.pacId, "value": e.prenom + ' ' + e.nom + ' - ' + calculateAge(e.dateNaissance) + ' ans ' + ' (au 1er janvier ' + actionSociale.exercice + ')'}));
        return items;
    }

    // calcul de l'âge en fonction du 1er janvier de l'exercice
    const calculateAge = (dob1) => {
        const formattedDate = dob1.split('/');
        const firstDate = new Date(actionSociale.exercice + '-01-01');
        const birthDate = new Date([formattedDate[2], formattedDate[1], formattedDate[0]].join('/'));  // create a date object directly from `dob1` argument
        let age = firstDate.getFullYear() - birthDate.getFullYear();
        const m = firstDate.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && firstDate.getDate() > birthDate.getDate())) age--;
        return age;
    }

    const getCurrentActionSociale = (asList, cas, exercice) => {
        Object.values(asList).forEach(as => {
            if(as.codeActionSociale === cas && as.exercice === exercice) {
                setCurrentActionSociale(as);
                return;
            }
        });
    };

    const getMontantTotalByDlg = (codeCas, dlgId ,exercice) => {
             actionSocialeService.getMontantTotalPrestation(codeCas, dlgId ,exercice).then((res) => {
                   setMontantTotalByDlg(res.data);
                }
             );
    };



    const getCurrentEnfant = () => {
        if(enfants.length === 0) return;
        enfants.forEach(enfant => {
            if(enfant.pacId === selectedEnfant) {
                setCurrentEnfant(enfant);
                setRecapEnfant([enfant.prenom, enfant.nom, '-', calculateAge(enfant.dateNaissance), 'an(s)'].join(' '));
                return;
            }
        });
    };

    const initActiveIndex = () => {
        if(createMode === mode) setActiveIndex([step]);
        if(editMode === mode) setActiveIndex([0,1,2,3,4]);
    };

    const nextStep = (e, increment) => {
        e.target.disabled = true;
        e.target.classList.add("disabled");
        e.target.style.pointerEvents = "none";
        e.target.style.display = "none";
        setStep(step + increment);
    };

    const disableSubmitCreate = () => {
        if(actionSociale.optJustificatif)
            return (!selectedEnfant && actionSociale.cas =="3743")  || !montantTotal || !(justificatifEnfant && justificatifEnfant.length >= 1) || !(justificatifPresence && justificatifPresence.length >= 1) || !policyOne || !policyTwo || disabled;
        else
            return (!selectedEnfant && actionSociale.cas =="3743")  || !montantTotal || !(justificatifEnfant && justificatifEnfant.length >= 1) || !policyOne || !policyTwo || disabled;
    };

    const disableSubmitEdit = () => {
        if(actionSociale.optJustificatif)
            return (!selectedEnfant && actionSociale.cas =="3743")   || !montantTotal
                || !((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant)
                || !((retourJustificatifPresence && justificatifPresence && justificatifPresence.length >= 1) || !retourJustificatifPresence)
                || !policyOne || !policyTwo || disabled;
        else
            return (!selectedEnfant && actionSociale.cas =="3743") || !montantTotal
                || !((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant)
                || !policyOne || !policyTwo || disabled;
    };

    const submitFormDemande = async (e) => {
        e.preventDefault();

        if(e.detail == 1){
            if(montantTotal < montantTotalByDlg){
                displayError('Montant des activités inférieur au montant minimum requis. Merci de corriger le montant.');
                return;
            }
            let formulaire = [{
                        "code": "NEA_PAC_LCI",
                        "valeur": actionSociale.cas === '3743' ? selectedEnfant.toString() : ""
                        },
                        {
                        "code": "NEA_DATE_DEBUT_LCI",
                        "valeur": new Date().toLocaleDateString("fr")
                        },
                        {
                        "code": "NEA_DATE_FIN_LCI",
                        "valeur": ""
                        }
            ];

            let checkActivities = true;
            activities.forEach( activity => {
                  if(activity.name=='' || activity.price==0 || activity.dateFacture == null){
                    checkActivities = false;
                    displayError('Des informations sont manquantes sur certaines des activités indiquées. Merci de compléter ou de supprimer ces activités.');
                    return;
                  }
                  let dateFactureFormated= [activity.dateFacture.getDate().toString().padStart(2, '0'), '/', (activity.dateFacture.getMonth()+1).toString().padStart(2, '0'), '/', activity.dateFacture.getFullYear()].join('');
                  formulaire.push({"code": "NEA_ACTIVITE_LCI","valeur": activity.name+" - "+dateFactureFormated+" - "+activity.price});
            });
            if(!checkActivities){
                 return;
             }

            formulaire.push({"code": "NEA_MONTANT_FRAIS_LCI","valeur": montantTotal.toString()});
            const jsonFormSchema = {
                        formulaire : formulaire
                    };

                    const demande = {
                        etape: "1",
                        exercice: actionSociale.exercice,
                        origine: "NEA",
                        codeClasseur: actionSociale.cas,
                        demandeStatutReferentiel: { id: 1 },
                        demandeDetails: [],
                    };

                    const demandeDetail = {
                        demandeType: {
                            codeActionSocial: actionSociale.cas === '3743' ? "3743" : "3742",
                        },
                        formJson: JSON.stringify(jsonFormSchema).toUpperCase(),
                        montant: montantTotal,
                        version: "1",
                    };

                    demande.demandeDetails.push(demandeDetail);

                    if((actionSociale.optJustificatif && ((selectedEnfant && actionSociale.cas =="3743") || actionSociale.cas =="3742") && (montantTotal && montantTotal >= montantTotalByDlg) && (justificatifEnfant && justificatifEnfant.length >= 1) && (justificatifPresence && justificatifPresence.length >= 1))
                        || (!actionSociale.optJustificatif && ((selectedEnfant && actionSociale.cas =="3743") || actionSociale.cas =="3742")  && (montantTotal && montantTotal >= montantTotalByDlg) && (justificatifEnfant && justificatifEnfant.length >= 1))) {
                        setDisabled(true);

                        let justificatifsPresenceList = [];
                        let justificatifsPrestaList = [];
                        if(actionSociale.optJustificatif && justificatifPresence && justificatifPresence.length > 0){
                            Object.values(justificatifPresence).forEach(jus => {
                                justificatifsPresenceList.push(jus.category[1]);
                            });
                        }
                        if (justificatifEnfant && justificatifEnfant.length > 0) {
                            Object.values(justificatifEnfant).forEach(jus => {
                                justificatifsPrestaList.push(jus.category[1]);
                            });
                        }

            //Pdf Recap : récupération de la liste des activités            
            let _activitesList = [];
            activities.forEach( value => { 
                let dateFactureFormated= [value.dateFacture.getDate().toString().padStart(2, '0'), '/', (value.dateFacture.getMonth()+1).toString().padStart(2, '0'), '/', value.dateFacture.getFullYear()].join('');                 
                let activite = {nom : value.name, date : dateFactureFormated, montant : value.price};
                _activitesList.push(activite);                
            });

            const infosDemandeClapDto = {
                "codeActionSociale": actionSociale.cas,
                "dateNaissance": actionSociale.cas === '3743' ? currentEnfant.dateNaissance: "",
                "depenses": montantTotal.toString().replace('.', ',') + ' €',
                "emailPersonnel": usager.email,
                "exercice": actionSociale.exercice,
                "iban": actionSociale.iban,
                "justificatifsPresence": justificatifsPresenceList,
                "justificatifsPresta": justificatifsPrestaList,
                "libelleActionSociale": actionSociale.cas === '3743' ? 'SPORTS LOISIRS CULTURE ENFANTS' : 'SPORTS LOISIRS CULTURE ADULTE',
                "nom": usager.nom,
                "nomNaissance": usager.nomNaissance,
                "nomEnfant": actionSociale.cas === '3743' ? currentEnfant.nom: "",
                "numCgos": usager.numCgos,
                "periodeCouverte": "",
                "positionStatutaire": actionSociale.fiche.libellePositionStatutaire,
                "prenom": usager.prenom,
                "prenomEnfant": actionSociale.cas === '3743' ? currentEnfant.prenom : "",
                "qf": actionSociale.fiche.quotientFamilial,
                "situationAdministrative": actionSociale.fiche.libelleSituationAdministrative,
                "etbLibelle": usager.libelleEtablissement,
                "activitesList" : _activitesList
                
            };
            fileService
                .uploadMultiFile(justificatifEnfant.concat(justificatifPresence))
                .then((res) => {
                    if (null != res.data && res.data != undefined) {
                        fileService.createRecaputilatifDemande(infosDemandeClapDto).then((response) => {
                            showInfo("Justificatif");
                            saveDemande(demande);
                        });
                    } else {
                        setShowFileUploadError(true);
                    }
                })
                .catch((err) => {
                    handleFilesError(err);
                }).finally(() => {
                    setDisabled(false);
                });
         }
        }
    };

    const saveDemande = (demande) => {
        chequeCultureService
            .submitDemandeForm(demande)
            .then((res) => {
                setDisplayBasic(true);
                showInfo("Demande");
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    };


    const displayError = (message) => {
        toast.current.show({
            severity: "error",
            summary: "ERREUR",
            detail: message,
            life: 5000,
        });
    }
    const displayErrorFile = (message) => {
                toast.current.show({
                    severity: "error",
                    summary: "ERREUR DE FICHIER",
                    detail: message,
                    life: 5000,
                });
            }

    // constitution de la liste des justifs à uploader en cas ce complément d'info
   let libelleJustifToDisplay = [];
   let codeJustifToUploadList = []; 
   let cloneJustifToUploadList = [];

   if (oldForm != null && oldForm.filesToUpload != null && oldForm.filesToUpload.length > 0) {             
        Object.values(oldForm.filesToUpload).forEach(file => {           
            if(!codeJustifToUploadList.includes(file.codeJustificatif)){
                codeJustifToUploadList.push(file.codeJustificatif);
            }            
            cloneJustifToUploadList.push(file.codeJustificatif);
            libelleJustifToDisplay.push(file.libelleJustificatifMotifSpecifique);
        });
        if(oldForm.siSupplementInfo){
                    codeJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
                    cloneJustifToUploadList.push(justificatifsCategoriesSupplement[0].key);
        }
    //    libelleJustifToDisplay.push(oldForm.noteRetourAgent);
    }


    const submitEditedDemande = async(e) => {
        e.preventDefault();

        // On recupère les codes dans justificatifEnfant
        let codeJustifEnfantList = [];
        if(justificatifEnfant != null && justificatifEnfant.length >=1){
            Object.values(justificatifEnfant).forEach(jus => {           
                codeJustifEnfantList.push(jus.category[0]);            
            });
       }
        // On recupère les codes dans justificatifPresence
        if(justificatifPresence != null && justificatifPresence.length >=1){
            Object.values(justificatifPresence).forEach(jus => {           
                codeJustifEnfantList.push(jus.category[0]);            
            });
        }

        // On recupère les codes dans justificatifSupplementInformations
        if(justificatifSupplementInformations != null && justificatifSupplementInformations.length >=1){
          Object.values(justificatifSupplementInformations).forEach(jus => {
              codeJustifEnfantList.push(jus.category[0]);
          });
        }

        //Controle des justifs à uploader
        let recapJustifToUpload = true;
        let cloneJustifToUploadListSpliced = [].concat(cloneJustifToUploadList);
        if(codeJustifToUploadList != null && codeJustifToUploadList.length >=1){
            Object.values(codeJustifEnfantList).forEach(jusCode => {      
                if(cloneJustifToUploadListSpliced.includes(jusCode) && cloneJustifToUploadListSpliced.indexOf(jusCode) > -1){
                    cloneJustifToUploadListSpliced.splice(cloneJustifToUploadListSpliced.indexOf(jusCode), 1);
                } 
            }); 

            if(cloneJustifToUploadListSpliced.length >=1){
                recapJustifToUpload = false;
            }                     
            if(recapJustifToUpload == false){    
                displayError('Un ou plusieurs des documents demandés sont manquants. Merci de compléter votre réponse');
                return;
            }
        }


        if(e.detail == 1){

            let formulaire = [{
                                    "code": "NEA_PAC_LCI",
                                    "valeur": actionSociale.cas === '3743' ? selectedEnfant.toString() : ""
                                    },
                                    {
                                    "code": "NEA_DATE_DEBUT_LCI",
                                    "valeur": dateDebutFromJson
                                    },
                                    {
                                    "code": "NEA_DATE_FIN_LCI",
                                    "valeur": ""
                                    }
                        ];
                        //add actvities to formJson


            activities.forEach( activity => {
                              let dateFactureFormated= [activity.dateFacture.getDate().toString().padStart(2, '0'), '/', (activity.dateFacture.getMonth()+1).toString().padStart(2, '0'), '/', activity.dateFacture.getFullYear()].join('');
                              formulaire.push({"code": "NEA_ACTIVITE_LCI","valeur": activity.name+" - "+dateFactureFormated+" - "+activity.price});
             });
            formulaire.push({"code": "NEA_MONTANT_FRAIS_LCI","valeur": montantTotal.toString()});
            const jsonFormSchema = {
                 formulaire : formulaire
            };

                    const demande = {
                        montantTotal: montantTotal,
                        demandeId: oldForm.demandeId,
                        recordId: oldForm.recordId,
                        filesToUpload: oldForm.filesToUpload,
                        formJson: JSON.stringify(jsonFormSchema).toUpperCase(),
                        codeActionSociale: oldForm.codeActionSociale,
                        exercice: oldForm.exercice
                    };


                    if(((actionSociale.optJustificatif || justificatifSupplementInformations.length >=1) && (montantTotal && montantTotal >= montantTotalByDlg)
                        && (((selectedEnfant && actionSociale.cas =="3743") || actionSociale.cas =="3742"))
                        && ((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant)
                        && ((retourJustificatifPresence && justificatifPresence && justificatifPresence.length >= 1) || !retourJustificatifPresence))
                        || ((!actionSociale.optJustificatif && ((selectedEnfant && actionSociale.cas =="3743") || actionSociale.cas =="3742") && (montantTotal && montantTotal >=montantTotalByDlg) && justificatifEnfant && justificatifEnfant.length)
                        && ((retourJustificatifEnfant && justificatifEnfant && justificatifEnfant.length >= 1) || !retourJustificatifEnfant))) {


                        setDisabled(true);

                        let justificatifsPresenceList = [];
                        let justificatifsPrestaList = [];
                        if(justificatifPresence && justificatifPresence.length > 0){
                            Object.values(justificatifPresence).forEach(jus => {
                                justificatifsPresenceList.push(jus.category[1]);
                            });
                        }
                        if (justificatifEnfant && justificatifEnfant.length > 0) {
                            Object.values(justificatifEnfant).forEach(jus => {
                                justificatifsPrestaList.push(jus.category[1]);
                            });
                        }
                        if (justificatifSupplementInformations && justificatifSupplementInformations.length > 0) {
                             Object.values(justificatifSupplementInformations).forEach(jus => {
                                 justificatifsPrestaList.push(jus.category[1]);
                             });
                        }

           //Pdf Recap : récupération de la liste des activités            
           let _activitesList = [];
           activities.forEach( value => { 
               let dateFactureFormated= [value.dateFacture.getDate().toString().padStart(2, '0'), '/', (value.dateFacture.getMonth()+1).toString().padStart(2, '0'), '/', value.dateFacture.getFullYear()].join('');                 
               let activite = {nom : value.name, date : dateFactureFormated, montant : value.price};
               _activitesList.push(activite);                
           });

            const infosDemandeClapDto = {
                "codeActionSociale": actionSociale.cas,
                "dateNaissance": actionSociale.cas === '3743' ?currentEnfant.dateNaissance:"",
                "depenses": montantTotal.toString().replace('.', ',') + ' €',
                "emailPersonnel": usager.email,
                "exercice": actionSociale.exercice,
                "iban": actionSociale.iban,
                "justificatifsPresence": justificatifsPresenceList,
                "justificatifsPresta": justificatifsPrestaList,
                "libelleActionSociale": actionSociale.cas === '3743' ? 'SPORTS LOISIRS CULTURE ENFANTS' : 'SPORTS LOISIRS CULTURE ADULTE',
                "nom": usager.nom,
                "nomNaissance": usager.nomNaissance,
                "nomEnfant": actionSociale.cas === '3743' ?currentEnfant.nom:"",
                "numCgos": usager.numCgos,
                "periodeCouverte": "",
                "positionStatutaire": actionSociale.fiche.libellePositionStatutaire,
                "prenom": usager.prenom,
                "prenomEnfant": actionSociale.cas === '3743' ?currentEnfant.prenom:"",
                "qf": actionSociale.fiche.quotientFamilial,
                "situationAdministrative": actionSociale.fiche.libelleSituationAdministrative,
                "etbLibelle": usager.libelleEtablissement,
                "activitesList" : _activitesList
            };
            let recordIds=oldForm.filesToUpload.map(file => file.recordId);
            let categories=oldForm.filesToUpload.map(file => file.codeJustificatif);
            if(recordIds?.length > 0){
                    fileService
                        .uploadEditedFiles(justificatifEnfant.concat(justificatifPresence).concat(justificatifSupplementInformations),recordIds,codeJustifToUploadList)
                        .then((res) => {
                            if (null != res.data && res.data != undefined) {
                                fileService.updateRecaputilatifDemande(infosDemandeClapDto, demande.demandeId).then((response) => {
                                    showInfo("Justificatif");
                                    saveEditedDemande(demande);
                                });
                            } else {
                                setShowFileUploadError(true);
                            }
                        })
                        .catch((err) => {
                            handleFilesError(err);
                        }).finally(() => {
                        setDisabled(false);
                    });

            }else if(justificatifSupplementInformations.length >=1){
                   fileService.uploadMultiFile(justificatifSupplementInformations)
                        .then((res) => {
                             if (null != res.data && res.data != undefined) {
                                  fileService.updateRecaputilatifDemande(infosDemandeClapDto, demande.demandeId).then((response) => {
                                       showInfo("Justificatif");
                                       saveEditedDemande(demande);
                                        });
                                 } else {
                                     setShowFileUploadError(true);
                                  }
                                    })
                                  .catch((err) => {
                                 handleFilesError(err);
                                 }).finally(() => {
                                  setDisabled(false);
                                });
            }
         }

        }

    };

    const formatDateActivities = (date) => {
        return new Date(date).toLocaleDateString("fr-FR", {})
    };

    const saveEditedDemande = (demande) => {
        chequeCultureService
            .submitEditedForm(demande)
            .then((res) => {
                setDisplayBasic(true);
                showInfo("Demande");
            })
            .catch((err) => {
                window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
            });
    };


    const showInfo = (msg) => {
        toast.current.show({
            severity: "info",
            summary: "Succès",
            detail: msg + " envoyée avec succès. ",
            life: 5000,
        });
    };

    const basicDialogFooter = (
        <Button
            type="button"
            label="RETOUR ESPACE AGENT"
            onClick={(e) => logoutRemoveData(e)}
            className="btn_submit_modal"
        />
    );

    const logoutRemoveData = (e) => {
        chequeCultureService.logOut().then((res) => {
            console.log(res);
        });
        handleAnnuler();
    };

    const handleAnnuler = () => {
        chequeCultureService.redirectEaLegacy();
    };

    return (
        <div className="formClap" style={{ marginTop: "1%" }}>
            <ChequeCultureLegacy />
            <Toast ref={toast} position="top-center" className="toast-position" />

            {true &&
            <div className="mx-auto">
                <div className="no_shadow_no_border card" style={{padding:0}}>
                    {(mapping &&
                    <form
                        action=""
                        id="espaceAgent"
                        method="POST"
                        name="formSport"
                        className="form-horizontal cld-form-padding"
                    >

                <Accordion activeIndex={activeIndex} multiple
                                              onTabChange={(e) => setActiveIndex(e.index)}>
                    <AccordionTab header="1 - Mes informations personnelles" disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-block-wrapper">
                                <h4>Mes informations personnelles</h4>
                                <dt>Numéro C.G.O.S</dt>
                                <dd>{usager.numCgos}</dd>
                                <dt>Etablissement</dt>
                                <dd>{usager.libelleEtablissement}</dd>
                                <dt>Civilité</dt>
                                <dd>{usager.civilite}</dd>
                                <dt>Prénom</dt>
                                <dd>{usager.prenom}</dd>
                                <dt>Nom</dt>
                                <dd>{usager.nom}</dd>
                                <dt>Nom de naissance</dt>
                                <dd>{usager.nomNaissance}</dd>
                                <dt>EMAIL PERSONNEL</dt>
                                <dd>{usager.email}</dd>
                            </div>
                        </dl>

                        <dl className="dl-horizontal">
                            <div className="form-block-wrapper">
                                <h4>Mes références bancaires</h4>
                                <dt>IBAN</dt>
                                <dd>{actionSociale.iban}</dd>
                            </div>
                        </dl>

                        <dl className="dl-horizontal">
                            <div className="form-block-wrapper">
                                <h4>Mon quotient familial</h4>
                                <dt>Quotient familial</dt>
                                <dd>{actionSociale.fiche.quotientFamilial ? actionSociale.fiche.quotientFamilial.toString().replace('.', ',') : "en cours de calcul ou avis d'impôt non communiqué"}</dd>
                                {actionSociale.cas =="3743" &&
                                <dt>Montant annuel max de la prestation/enfant</dt>}
                                {actionSociale.cas =="3742" &&
                                <dt>Montant annuel max de la prestation</dt>}
                                <dd>{actionSociale.maxVal} €</dd>
                            </div>
                        </dl>
                        <p className="form-block-info">
                            Si j’ai besoin de modifier une information, je consulte les rubriques <br/>
                            •     <a href={linkService.getRetourEaMembreFiche()} target="_blank" aria-label="page depuis laquelle faire une demande pour modifier mes données personnelles"> <b>Données personnelles</b><br/></a>
                            •     <a href={linkService.getRetourEaPreferenceBancaires()} target="_blank" aria-label="page depuis laquelle faire une demande pour modifier mes références bancaires"> <b>Références bancaires </b><br/></a>
                            <br/>
                            Si j’ai d’autres questions ou changements à faire, je vais à la rubrique  <br/>
                            •    <a target="_blank" href={linkService.getRetourEaContacterNous()} aria-label="page depuis laquelle envoyer une demande de changement de situation"> <b>Nous contacter</b></a>
                        </p>

                        {createMode === mode &&
                        <div className="next-button-wrapper">
                            <button type="button" className="next-button button-arrow" onClick={(e) => nextStep(e, 1)} >Etape suivante</button>
                        </div>}
                    </AccordionTab>

                    <AccordionTab header={actionSociale.cas =="3743" ? "2 - L'enfant et les activités pratiquées" : "2 - Les activités pratiquées"} disabled={true}>

                                            <dl className="dl-horizontal">
                                                {actionSociale.cas =="3743" ?
                                                <div className="form-block-wrapper" style={{ border: incompleteSelectedEnfant ? '3px solid red' : ''}}>
                                                    <h4>Je sélectionne mon enfant </h4>
                                                    <p className="form-block-info">
                                                             <ul className="form-block-info" >
                                                             <li>Seuls les enfants déclarés et éligibles pour l’année concernée sont affichés. </li>
                                                             <li>En cas d’anomalie, je m’adresse au contact C.G.O.S de mon établissement ou je m’adresse directement au C.G.O.S depuis la rubrique <b>Nous contacter.</b> </li>
                                                             </ul>
	                                                </p>
                                                    {<FieldBuilder code={'NEA_PAC_LCI'} items={[mapEnfants(), selectedEnfant]} onValueChange={(e) => setSelectedEnfant(e.value)} disabled={editMode === mode} />}
                                                </div>:''}

                                                <div className="form-block-wrapper">


                                                    <h4>J'indique la ou les activités pratiquées</h4>


                                                    {actionSociale.cas =="3743" &&
                                                    <div style={{ border: incompleteActivity ? '3px solid red' : ''}}>
                                                        <FieldBuilder code={'NEA_ACTIVITIES'}  items={[activities,setActivities,setMontantTotal,actionSociale.exercice,true,selectedEnfant,setIncompleteSelectedEnfant,setIncompleteActivity]}  />
                                                    </div>}
                                                    {actionSociale.cas =="3742" &&
                                                      <div style={{ border: incompleteActivity ? '3px solid red' : ''}}>
                                                        <FieldBuilder code={'NEA_ACTIVITIES'}  items={[activities,setActivities,setMontantTotal,actionSociale.exercice,false,null,setIncompleteSelectedEnfant,setIncompleteActivity]}  />
                                                      </div>}

                                                    <p></p>



                                                    <p></p>
                                                    <p className="form-block-info">
                                                        Montant cumulé des activités. <b>Minimum {montantTotalByDlg} €</b>.
                                                    </p>
                                                     <div className="field">
                                                        <InputNumber inputId="montantTotal" value={montantTotal} placeholder="Montant en euros" disabled={true} mode="currency" currency="EUR" locale="fr-FR" maxFractionDigits={2}/>
                                                     </div>
                                                     <button type="button"  class={(montantTotal<montantTotalByDlg)? "disabled" : "buttonAdd primary"}  onClick={(e) =>  onClickAjouterMesJustificatif(e)}>Ajouter mes documents justificatifs</button>
                                                </div>                                                
                                            </dl>



                                            <dl className="dl-horizontal" style={{ display: (editMode === mode || (montantTotal && montantTotal >= montantTotalByDlg && !incompleteActivity && !incompleteSelectedEnfant))? 'initial' : 'none' }}>
                                                <div className="form-block-wrapper" style={{ border: editMode === mode && (retourJustificatifEnfant || oldForm.siSupplementInfo || supplementErrone)? '3px solid red' : ''}}>
                                                    {editMode === mode &&  (libelleJustifToDisplay.length >= 1 || oldForm.siSupplementInfo || supplementErrone) &&
                                                        <div className="info-wrapper-2" style={{backgroundColor:'lightyellow', justifyContent:'left'}}>
                                                            <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif"}}>
                                                                <h4>Liste des justificatifs avec des observations du C.G.O.S :</h4>
                                                                   <ul>
                                                                        {Object.entries(libelleJustifToDisplay).map(([key,val]) =>(
                                                                           <li>{val}</li>
                                                                        ))}
                                                                   </ul>

                                                                <br></br>
                                                                
                                                                <h4>Autres observations ou justificatif complémentaire demandé par le C.G.O.S:</h4>
                                                                    <ul>
                                                                        <li>{oldForm.noteRetourAgent}</li>
                                                                    </ul>

                                                                <br></br>
                                                                <h4>Pour votre réponse,</h4>
                                                                      <ul>
                                                                         <li> Utilisez exclusivement ce formulaire pour renvoyer des justificatifs.</li>
                                                                         <li> N’envoyez pas les informations demandées seules. Renvoyez toujours avec elles le justificatif principal en même temps.</li>
                                                                         <li> Envoyez à minima le même nombre et le même type justificatifs que ceux mentionnés dans les observations ci-dessus.</li>
                                                                      </ul>
                                                            </span>

                                                        </div>}
                                                    
                                                    <h4>Je télécharge les documents justificatifs</h4>
                                                    {((editMode === mode && libelleJustifToDisplay.length >= 1) || createMode === mode )&&
                                                    <div className="form-block-wrapper">
                                                    <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, actionSociale.cas === '3743' ? justificatifsCategoriesEnfant : justificatifsCategoriesAdult, 10000000, true, retourJustificatifEnfant ? editJustificatifMsg : null,editCategoryJustif]} onValueChange={(e) => setJustificatifEnfant(e)} disabled={false} />
                                                    </div>}

                                                    {(editMode === mode && (oldForm.siSupplementInfo || supplementErrone )) &&
                                                    <dl className="dl-horizontal" >
                                                      <div className="form-block-wrapper">
                                                        <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsCategoriesSupplement, 10000000, false, null,"testDesciption"]} onValueChange={(e) => setJustificatifSupplementInformations(e)} disabled={false} />
                                                      </div>
                                                    </dl>}
                                                </div>
                                            </dl>
                                            

                                            {createMode === mode &&
                                            <div className="next-button-wrapper">
                                                <button type="button"
                                                        className={(!selectedEnfant && actionSociale.cas =="3743")  || !montantTotal || !(justificatifEnfant && justificatifEnfant.length > 0)
                                                            ? "next-button button-arrow disabled"
                                                            : "next-button button-arrow"}
                                                        style={(!selectedEnfant && actionSociale.cas =="3743") || !montantTotal || !(justificatifEnfant && justificatifEnfant.length > 0)
                                                            ? {pointerEvents: "none"}
                                                            : {}}
                                                        onClick={(e) => nextStep(e, actionSociale?.optJustificatif ? 1 : 2)}
                                                        disabled={(!selectedEnfant && actionSociale.cas =="3743")  || (!montantTotal && montantTotal < montantTotalByDlg) || !(justificatifEnfant && justificatifEnfant.length > 0)} >
                                                    Etape suivante
                                                </button>
                                            </div>}


                        </AccordionTab>




                    {((actionSociale?.optJustificatif  && createMode === mode )||(editMode === mode && retourJustificatifPresence ) ) ?
                    <AccordionTab header="3 - J’ajoute mon justificatif de présence" disabled={true}>
                        <dl className="dl-horizontal" style={{ border: editMode === mode && retourJustificatifPresence ? '3px solid red' : '', display : editMode === mode && !retourJustificatifPresence ? 'none' : '' }}>
                            <div className="form-block-wrapper">
                                <FieldBuilder code={'NEA_JUSTIFICATIF'} items={[mimeTypes, justificatifsCategories3, 10000000, false, retourJustificatifPresence ? editJustificatifMsg : null]} onValueChange={(e) => setJustificatifPresence(e)} disabled={false} />
                            </div>
                        </dl>

                       {createMode === mode &&
                                                 <div className="next-button-wrapper">
                                                     <button type="button"
                                                             className={!(justificatifPresence && justificatifPresence.length > 0)
                                                                 ? "next-button button-arrow disabled"
                                                                 : "next-button button-arrow"}
                                                             style={!(justificatifPresence && justificatifPresence.length > 0)
                                                                 ? {pointerEvents: "none"}
                                                                 : {}}
                                                             onClick={(e) => nextStep(e, 1)}
                                                             disabled={!(justificatifPresence && justificatifPresence.length > 0)} >
                                                         Etape suivante
                                                     </button>
                                                 </div>}
                                             </AccordionTab>
                                             : ''}

                    <AccordionTab header={((actionSociale?.optJustificatif  && createMode === mode )||(editMode === mode && retourJustificatifPresence ) ) ? '4 - Récapitulatif de ma demande' : '3 - Récapitulatif de ma demande'} disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-recap form-block-wrapper">
                                <dt>Année concernée</dt>
                                <dd>{ actionSociale?.exercice ? actionSociale.exercice : '' }</dd>
                                <dt>Prestation demandée</dt>
                                <dd>
                                    { currentActionSociale.codeLibelle }
                                </dd>
                                {actionSociale.cas =="3743" &&
                                <dt>Enfant concerné</dt>}
                                {actionSociale.cas =="3743" && <dd>{ recapEnfant }</dd>}

                                <dt>Activités déclarées</dt>
                                <dd>
                                    <ul>
                                        { activities && activities.length > 0 &&
                                        Object.entries(activities).map(([key, value], index) => <li key={index}><b className="textLongBreak">{value.name}</b> - {formatDateActivities(value.dateFacture)} - {value.price} €</li>) }
                                    </ul>
                                </dd>

                                <dt>Montant total des dépenses</dt>
                                <dd>{ montantTotal ? montantTotal.toString().replace('.', ',') : 0 } €</dd>
                                <dt>Justificatif(s) fourni(s)</dt>
                                <dd>
                                    <ul>
                                        { justificatifEnfant && justificatifEnfant.length > 0 &&
                                        Object.entries(justificatifEnfant).map(([key, value], index) => <li key={index}><b className="textLongBreak">{value.file.name}</b> - {value.category[1]}</li>) }
                                    </ul>
                                    <ul>
                                        { justificatifSupplementInformations && justificatifSupplementInformations.length > 0 &&
                                          Object.entries(justificatifSupplementInformations).map(([key, value], index) => <li key={index}><b className="textLongBreak">{value.file.name}</b> - {value.category[1]}</li>) }
                                    </ul>
                                </dd>
                                {
                                    (actionSociale.optJustificatif || justificatifPresence.length > 0)
                                        ?   (<div>
                                                <dt>Justificatif de présence</dt>
                                                <dd>
                                                    <ul>
                                                        { justificatifPresence && justificatifPresence.length > 0 &&
                                                        Object.entries(justificatifPresence).map(([key, value], index) => <li key={index}><b className="textLongBreak">{value.file.name}</b> - {value.category[1]}</li>) }
                                                    </ul>
                                                </dd>
                                            </div>)
                                        :   ''
                                }
                            </div>
                        </dl>

                        {createMode === mode &&
                        <div className="next-button-wrapper">
                            <button type="button" className="next-button button-arrow" onClick={(e) => nextStep(e, 1)} >Etape suivante</button>
                        </div>}
                    </AccordionTab>

                    <AccordionTab header={((actionSociale?.optJustificatif  && createMode === mode )||(editMode === mode && retourJustificatifPresence ) ) ? '5 - Signature et envoi de ma demande' : '4 - Signature et envoi de ma demande'} disabled={true}>
                        <dl className="dl-horizontal">
                            <div className="form-sign form-block-wrapper">
                                <div className="field-checkbox">
                                    <Checkbox inputId="sign1" checked={policyOne} onChange={e => setPolicyOne(e.checked)} />
                                    <label htmlFor="sign1">Je déclare sur l’honneur l’exactitude des informations concernant ma situation professionnelle, familiale et financière et je déclare être informé que quiconque se rend coupable de fraude, production de documents falsifiés comme justificatifs, fausses déclarations est passible des peines d’amendes et/ou d’emprisonnement.</label>
                                </div>
                                <div className="field-checkbox">
                                    <Checkbox inputId="sign2" checked={policyTwo} onChange={e => setPolicyTwo(e.checked)} />
                                    <label htmlFor="sign2">J’ai lu et j’approuve  la politique de gestion des données à caractère personnel renseignées dans ce formulaire.</label>
                                </div>
                                <div id="textarea" >
                                    <span>{text}</span>
                                     <br></br>
                                        <p>
                                    Pour en savoir plus, consultez la <a href='https://www.cgos.info/17/politique-protection-donnees' target='_blank'>page d'information sur la politique de protection des données du C.G.O.S.</a>
                                        </p>
                                </div>

                            </div>
                        </dl>

                        <div className="info-wrapper-2">
                            <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                Une fois votre demande traitée, vous recevrez une information par Email.
                                Vous pouvez également suivre son avancement depuis la rubrique{" "}
                                <a href={linkService.getRetourEaMembreSuiviDemande()}>Mes suivis{" "}</a>de votre Espace Agent.
                            </span>
                        </div>

                        <div className="form-group">
                            <div className="navButtons cld-submit-buttons">
                                <button className="btn invalide" type="button" style={{ backgroundColor: "#C9C9C9" }} name="RETOUR_PRESTATION" onClick={logoutRemoveData}>ANNULER</button>
                                { createMode == mode && <button className="btn" type="button" onClick={submitFormDemande} name="ENVOYER_MA_DEMANDE" disabled={disableSubmitCreate()}>Envoyer ma demande</button> }
                                { editMode == mode && <button className="btn" type="button" onClick={submitEditedDemande} name="ENVOYER_MA_DEMANDE" disabled={disableSubmitEdit()}>Envoyer ma demande</button> }
                            </div>
                        </div>
                   </AccordionTab>
                </Accordion>
                        <Dialog
                            closable={false}
                            header=""
                            visible={displayBasic}
                            modal
                            footer={basicDialogFooter}
                        >
                            <center>
                                <h2>
                                    Votre demande de prestation a bien été envoyée et sera étudiée prochainement. <br />{" "}
                                </h2>
                                <br />
                                <h4>
                                    Vous pouvez suivre son avancement depuis la rubrique{" "}
                                    <a href={linkService.getRetourEaMembreSuiviDemande()}><b>Mes suivis</b>{" "}</a>de votre Espace Agent.
                                </h4>
                                <br />
                            </center>
                        </Dialog>

                        <Dialog closable={false} header="" visible={showDemandeError} modal>
                            <center>
                                <h2>
                                    Un problème est survenu lors de l'envoi de votre demande de
                                    prestation : <b>{codeError}</b>
                                    <br />
                                </h2>
                                <br />
                                <h3>
                                    Pour renvoyer votre demande allez sur le formulaire de demande{" "}
                                </h3>
                                <br />
                                <br />
                                <h3>puis cliquez de nouveau sur le bouton d’envoi.</h3>
                                <br />
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>

                        <Dialog
                            closable={false}
                            header=""
                            visible={showFileUploadError}
                            modal
                        >
                            <center>
                                <h2>
                                    Echec d'envoi de votre demande de prestation Chèques culture{" "}
                                    <br />
                                </h2>
                                <br />
                                <h3>
                                    En raison d’un problème technique : <b>{codeError}</b> les
                                    documents joints à votre demandes n’ont pas pu être
                                    enregistrés.
                                </h3>
                                <br />
                                <h3>
                                    Merci de nous renvoyer votre demande après vous être assuré
                                    que les documents joints à celle-ci sont conformes aux
                                    caractéristiques (taille, format) indiquées sur le formulaire.
                                </h3>
                                <br />
                                <Button
                                    type="button"
                                    label="RÉAFFICHER LE FORMULAIRE"
                                    onClick={() => window.location.reload(false)}
                                    className="btn_submit_modal"
                                />
                            </center>
                        </Dialog>
                    </form>
                    )}
                </div>
            </div>}
        </div>
    );
};
